import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const getSavedMerchants = () => {
    return axiosPrivate.get(`/bills/api/v1/distributor/beneficiaries/`)
}